import { render, staticRenderFns } from "./VProductDates.vue?vue&type=template&id=86f361d6"
import script from "./VProductDates.vue?vue&type=script&lang=js"
export * from "./VProductDates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports